import type { GetServerSideProps } from "next";
import { getServerSidePropertiesNeededForEveryPage } from "utils/getRequestNeededForServicesFromContext";
import type { IConfig } from "config/IConfig";
import HelpContainer from "components/HelpContainer";
import { ServiceProvider } from "contexts/ServiceContext";
import { ProfilePageTypes } from "enums/ProfilePageTypes";
import useCreateServices from "hooks/useCreateServices";
import type { ITexts } from "translations/ITexts";
import type { IRequestNeededForServices } from "types/IRequestNeededForServices";
import useInitAnalytics from "hooks/useInitAnalytics";
import createServices from "services/createServices";
import { QueryClient } from "react-query";
import { dehydrate, DehydratedState } from "react-query/hydration";
import { PROFILE_QUERY_KEY } from "queries/queryKeys";
import { useEffect } from "react";
interface IProps {
    configs: IConfig;
    texts: ITexts;
    req: IRequestNeededForServices;
    dehydratedState: DehydratedState;
}

export default function Help({ configs, req, texts }: IProps) {
    const services = useCreateServices(configs, texts, ProfilePageTypes.HELP, req);

    useInitAnalytics(services);

    useEffect(
        () => {
            services.TiendeoStatsClient.Navigation(0);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    return (
        <ServiceProvider Services={services}>
            <HelpContainer />
        </ServiceProvider>
    );
}

export const getServerSideProps: GetServerSideProps<IProps> = async (context) => {
    const { configs, req, texts, res } = getServerSidePropertiesNeededForEveryPage(context);

    const { AuthApiClient } = createServices(
        configs,
        texts,
        ProfilePageTypes.HELP,
        req as any,
        res,
    );

    const queryClient = new QueryClient();

    await queryClient.prefetchQuery(PROFILE_QUERY_KEY, () => AuthApiClient.User.GetProfile());

    return {
        props: {
            configs,
            req,
            texts,
            dehydratedState: dehydrate(queryClient),
        },
    };
};
